import { render } from "./IconThankYou.vue?vue&type=template&id=d8b29ef8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconThankYou.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8b29ef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8b29ef8', __exports__)) {
    api.reload('d8b29ef8', __exports__)
  }
  
  module.hot.accept("./IconThankYou.vue?vue&type=template&id=d8b29ef8", () => {
    api.rerender('d8b29ef8', render)
  })

}


export default __exports__